import React, { useCallback, useEffect, useState } from 'react'

import { CloseIcon, PrimaryButton } from 'components'
import Modal from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import ProfileLabel from 'components/Profile/ProfileLabel'
import ProfileSelect from 'components/Profile/ProfileSelect'
import ProfileInput from 'components/Profile/ProfileInput'
import ProfileTextarea from 'components/Profile/ProfileTextarea'

import { OVERLAY } from 'components/AuthModal/styles'

const Input = ({ name, type, required, options, input, onChange }) => {
  const params = {
    name,
    value: input[name],
    onChange: onChange,
    required: required,
  }

  switch (type) {
    case 'select':
      return <ProfileSelect {...params} options={options} />
    case 'textarea':
      return <ProfileTextarea {...params} />
    default:
      return <ProfileInput {...params} type={type} />
  }
}

const InputModal = ({ show, onClose, onSubmit, title, requiredData }) => {
  const [input, setInput] = useState({})

  useEffect(() => {
    setInput({})
  }, [show])

  const handleInputChange = useCallback(e => {
    const { name, value } = e.target

    setInput(prev => ({
      ...prev,
      [name]: value,
    }))
  }, [])

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault()
      onSubmit(input)
    },
    [onSubmit, input]
  )

  return (
    <Overlay show={show} className={OVERLAY} preventEscBackdropClose={true} onClose={onClose}>
      <Modal innerClassName="bg-white rounded-t-3xl overflow-y-scroll md:rounded-xl">
        <div className="relative w-full p-5 md:p-7 md:py-5 md:w-108">
          <button className="bg-transparent absolute top-3 right-4" onClick={onClose}>
            <CloseIcon className="w-3 h-3" />
          </button>
          <div className="text-center text-xl font-bold font-ownersWide mb-10 underline">
            {title}
          </div>

          {requiredData && (
            <form onSubmit={handleSubmit}>
              <div className="text-center">
                {requiredData.map(requiredData => (
                  <div key={requiredData.type} className="mb-6">
                    <ProfileLabel className="text-black font-semibold">
                      {requiredData.label}
                    </ProfileLabel>
                    <Input {...requiredData} input={input} onChange={handleInputChange} />
                  </div>
                ))}
              </div>
              <div className="flex justify-center mt-14">
                <PrimaryButton type="submit" className="text-base h-10">
                  Submit
                </PrimaryButton>
              </div>
            </form>
          )}
        </div>
      </Modal>
    </Overlay>
  )
}

export default InputModal
